import { apiInstance } from '@/api/instance';
import { type PartnerAccountResponse } from '@/api/routes/partners/partners.api';

/** Contract: bodyprint-api/docs/external-apis/partners-contract.md (Convite para reivindicar a conta). */
export const partnersInvitesApi = {
  /** 403 when the session e-mail is not the invited one, 409 when the user already has an account. */
  accept: (token: string) =>
    apiInstance.post<PartnerAccountResponse>(
      `partners/invites/${encodeURIComponent(token)}/accept`,
    ),
};
